<template lang="pug">
div.userlist
    div
        Table(:columns="columns1" :data="Seelist")
        Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
         :page-size="10" show-elevator)
        span.pagecount 当前页面共有{{currentNum}}条数据，共有{{totalNum}}条数据
        Modal(class=frame v-model="modal1" title="审核")
          span(style="margin-right: 20px;font-weight: bold;").result 审核结果
          RadioGroup(v-model="single")
            Radio(label="未通过" :disabled="Formdisabled==='未审核'?false:true")
              span 不通过
            Radio(label="通过" :disabled="Formdisabled==='未审核'?false:true")
                span 通过
          h6(style="margin:20px 0 10px 0 ").proposal 审核建议
          Input(v-model="value" type="textarea" placeholder="填写建议..." :disabled="Formdisabled==='未审核'?false:true")
          div(slot="footer")
            Button(@click="cancel") 取消
            Button(@click="ok" style="background:#57A3F3;color:#fff" :disabled="Formdisabled==='未审核'?false:true") 保存
</template>

<script>
export default {
  data() {
    return {
      Formdisabled: "",
      modalData: "",
      currentNum: 0,
      totalNum: 0,
      pageData: {}, // 表格分页数据
      page: 1,
      Seelist: [],
      modal1: false,
      single: "",
      value: "",
      Unknown: "",
      caseDescription: "",
      caseName: "",
      editorOption: "",
      userId: "",
      className: "",
      columns1: [
        {
          title: "实验班级",
          width: "150",
          key: "className"
        },
        {
          title: "创建者",
          width: "100",
          key: "userName"
        },
        {
          title: "实验名称",
          width: "150",
          key: "caseExperimentName"
        },
        {
          title: "创建时间",
          width: "150",
          key: "releaseTime"
        },
        {
          width: "100",
          title: "提交次数",
          key: "submitContent"
        },
        {
          title: "审核状态",
          width: "300",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "10px",
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.auditStatus === "未通过"
                        ? "#ccc"
                        : params.row.auditStatus === "通过"
                          ? "#4AA55D"
                          : "#F04B60"
                  }
                },
                "●"
              ),
              h(
                "span",
                {
                  class: "centent",
                  style: params.row.auditStatus === "未通过" ? "color:#ccc" : ""
                },
                params.row.auditStatus
              )
            ]);
          },
          key: "auditStatus"
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "icon-chakan iconfont",
                style: "font-size:16px;color:#3A76D2",
                on: {
                  click: () => {
                    this.preview(params.row.pyId);
                    // this.confirm(params.row);
                  }
                }
              }),
              h(
                "span",
                {
                  style:
                    "font-size:20pxfont-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(58,118,210,1);line-height:18px;margin-left:5px;cursor:pointer",
                  on: {
                    click: () => {
                      this.preview(params.row.pyId);
                      // this.confirm(params.row);
                    }
                  }
                },
                "查看"
              ),
              h("span", {
                style: "width:0;height:5px;border:1px solid #ccc;margin-left:5px"
              }),
              h("i", {
                class: "icon-shenhe iconfont",
                fixed: "center",
                style: "font-size:16px;margin-left:5px;color:rgba(58,118,210,1)",
                on: {
                  click: () => {
                    this.modal1 = true;
                    this.Unknown = params.row.pyId;
                    this.caseDescription = params.row.caseDescription;
                    this.caseName = params.row.caseExperimentName;
                    this.userId = params.row.userId;
                    this.className = params.row.className;
                    this.editorOption = params.row.editorOption;
                    this.value = params.row.auditContent;
                    this.Formdisabled = params.row.auditStatus;
                    console.log(params.row);
                    if (params.row.auditStatus === "未审核") {
                      this.single = "";
                      this.modalData = params.row;
                      this.value = "";
                      console.log(this.modalData);
                    } else if (params.row.auditStatus === "未通过") {
                      this.single = "未通过";
                      this.modalData = params.row;
                      this.value = params.row.auditContent;
                    } else if (params.row.auditStatus === "通过") {
                      this.single = "通过";
                      this.modalData = params.row;
                      this.value = params.row.auditContent;
                    }
                  }
                }
              }),
              h(
                "span",
                {
                  style:
                    "font-size:20pxfont-size:14px;font-family:MicrosoftYaHeiUI;color:rgba(58,118,210,1);line-height:18px;margin-left:5px;cursor:pointer",
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.Unknown = params.row.pyId;
                      this.caseDescription = params.row.caseDescription;
                      this.caseName = params.row.caseExperimentName;
                      this.userId = params.row.userId;
                      this.className = params.row.className;
                      this.editorOption = params.row.editorOption;
                      this.value = params.row.auditContent;
                      this.Formdisabled = params.row.auditStatus;
                      console.log(params.row);
                      if (params.row.auditStatus === "未审核") {
                        this.single = "";
                        this.modalData = params.row;
                        this.value = "";
                        console.log(this.modalData);
                      } else if (params.row.auditStatus === "未通过") {
                        this.single = "未通过";
                        this.modalData = params.row;
                        this.value = params.row.auditContent;
                      } else if (params.row.auditStatus === "通过") {
                        this.single = "通过";
                        this.modalData = params.row;
                        this.value = params.row.auditContent;
                      }
                    }
                  }
                },
                "审核"
              )
            ]);
          }
        }
      ]
      // data1: [
      //   {
      //     index: "1",
      //     userName: "张三丰",
      //     className: "三年二班",
      //     classtype: "结构化实训",
      //     caseExperimentName: "XXXXXXXXXXXXX案例",
      //     releaseTime: "2019-10-03",
      //     auditStatus: "未审核"
      //   }
      // ]
    };
  },
  methods: {
    cancel() {
      this.modal1 = false;
    },
    preview(id) {
      const data = {
        caseStep: "FORMULATE",
        pyId: id
      };
      this.$http.getCasehallByPyIdAndCaseStep(data).then(res => {
        console.log(res);
        const data1 = {
          index: "FORMULATE",
          tsId: res.data.data.id,
          stageShow: res.data.data.stageShow
        };
        this.$store.commit("postStuCaseInformation", data1);
        const data3 = {
          caseExperimentId: id,
          experimentId: -1
        };
        sessionStorage.setItem("doIndex", -1);
        sessionStorage.setItem("pageIndex", 0);
        sessionStorage.setItem("willDoIndex", 4);
        this.$store.commit("postStuCaseId", data3);
        this.$router.push("/preview");
      });
    },
    ok() {
      if (this.modalData.auditStatus !== "未审核") {
        this.$Message.warning("不能重复审核");
      } else {
        console.log(this.single);
        console.log(this.editorOption);
        const data = new FormData();
        data.append("auditStatus", this.single);
        data.append("id", this.Unknown);
        data.append("caseDescription", this.caseDescription);
        data.append("caseName", this.caseName);
        data.append("className", this.className);
        data.append("userId", this.userId);
        data.append("auditContent", this.value);
        data.append("editorOption", this.editorOption);
        this.$http.updateCaseExperiment(data).then(res => {
          if (res.data.success) {
            this.examinequery();
            this.$Message.success("审核成功");
            this.modal1 = false;
          }
        });
      }
      // this.$Message.info("保存成功");
    },
    handleCurrentChange(page) {
      // 分页函数
      this.page = page;
      this.getTeacherlist();
    },
    getTeacherlist() {
      const data = {
        auditStatus: '["未审核","通过","未通过"]',
        isTeacherExp: false,
        pageNo: this.page,
        pageSize: 20
      };
      this.$http.NeedApprovalcustomCaselist(data).then(res => {
        console.log(res.data);
        if (res.data.success) {
          this.Seelist = res.data.data.list;
          this.currentNum = res.data.data.list.length;
          console.log(this.Seelist);
          // this.Seelist.forEach(e => {
          //
          // });
        }
      });
    },
    querytotalNum() {
      const data = {
        auditStatus: '["未审核","通过","未通过"]',
        isTeacherExp: false
      };
      this.$http.NeedApprovalcustomCaselist(data).then(res => {
        console.log(res.data);
        if (res.data.success) {
          this.Seelist = res.data.data.list.sort((a, b) => {
            return b.releaseTime > a.releaseTime ? 1 : -1;
          });
          this.totalNum = res.data.data.list.length;
          console.log(this.totalNum);
          // this.Seelist.forEach(e => {
          //
          // });
        }
      });
    },
    examinequery() {
      // 查询需要审批学生自定义案例
      const data = {
        auditStatus: '["未审核","通过","未通过"]',
        isTeacherExp: false,
        pageNo: 1,
        pageSize: 20
      };
      this.$http.NeedApprovalcustomCaselist(data).then(res => {
        console.log(res.data);
        if (res.data.success) {
          // this.Seelist = res.data.data.list;
          this.currentNum = res.data.data.list.length;
          this.Seelist = res.data.data.list.sort((a, b) => {
            return b.releaseTime > a.releaseTime ? 1 : -1;
          });
          console.log(this.Seelist);
          // this.Seelist.forEach(e => {
          //
          // });
        }
      });
    }
  },
  created() {
    this.examinequery();
    this.querytotalNum();
  }
};
</script>

<style lang="stylus">
.userlist
  position relative
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            border-top 1px solid #b7b7b7
            border-collapse unset
            box-sizing border-box
            height 40px
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 0.75)
            line-height 18px
          td:nth-child(5)
            text-align center
          &:first-child
            border-left 1px solid #b7b7b7
            border-radius 8px 0 0 8px
          &:last-child
            border-right 1px solid #b7b7b7
            border-radius 0 8px 8px 0
          &:last-child
            td
              border-bottom 1px solid #b7b7b7 !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .page
    margin-top 30px
    float right
  .pagecount
    position absolute
    bottom -57px;
    right 262px;
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    color:rgba(153,153,153,1);
    line-height:18px;
  .frame
    .result
      font-size 16px
      font-family MicrosoftYaHei
      font-weight 400
      margin-right 20px
</style>
